export default class GetProductInfoArgs {
    public categoryId = 0;
    public productId = 0;
    public shouldGetProductGroupDetails: boolean | undefined = false;
}
